import React from "react";
import {
  Routes,
  Route
} from "react-router-dom";

import Homepage from "./components/HomePage";
import CategoryLanding from "./components/CategoryLanding";
import MainLayout from "./MainLayout";
import ScrollToTop from "./ui/ScrollToTop";
import { ToolModalProvider } from "./hooks/ToolModalContext";
import { AnalyticsRouteTracker } from "./analytics";
import CostEstimatorPage from "./components/tools/cost-estimator/CostEstimatorPage";
import ProjectDiagnosticPage from "./components/tools/project-diagnostic/ProjectDiagnosticPage";
import MeasurementCalculatorPage from "./components/tools/measurement-calculator/MeasurementCalculatorPage";
import AccessibilityPlannerPage from "./components/tools/accessibility-planner/AccessibilityPlannerPage";
import InspirationExplorerPage from "./components/tools/inspiration-explorer/InspirationExplorerPage";
import ProjectReadinessPage from "./components/tools/project-readiness/ProjectReadinessPage";
import FinancingPage from "./components/tools/financing/FinancingPage";
import SurveyPage from "./components/SurveyPage";
import SurveyCompletePage from "./components/SurveyCompletePage";
import ViewReport from "./components/ViewReport"
import RoomIdeaGenerator from "./components/RoomIdeaGenerator";
import PrivacyConfirmed from "./components/PrivacyConfirmed";
import ServiceProviders from "./components/ServiceProviders";
import ServiceProviderProfile from "./components/ServiceProviderProfile";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import DoNotSell from "./components/DoNotSell";
import FAQPage from "./components/faqs";
import PropertyReportPage from "./components/PropertyReportPage";
import CaliforniaHiddenTaxFeeTransparencyPetition from "./components/CaliforniaHiddenTaxFeeTransparencyPetition";

export default function App() {
  return (
    <>
      <AnalyticsRouteTracker />
      {/* 🔝 FORCE SCROLL TO TOP ON ROUTE CHANGE */}
      <ScrollToTop />
      <ToolModalProvider>
        <Routes>
          {/* 📄 PROVIDER DIRECTORY */}
          <Route
            path="/providers"
            element={<ServiceProviders />}
          />

          {/* 👤 PROVIDER PROFILE */}
          <Route
            path="/providers/:id"
            element={<ServiceProviderProfile />}
          />

          {/* 🌐 SHARED LAYOUT */}
          <Route element={<MainLayout />} />

          {/* 🏠 HOMEPAGE */}
          <Route path="/" element={<Homepage />} />

          {/* 📋 CATEGORY LANDING */}
          <Route path="/:zip/:category" element={<CategoryLanding />} />
          <Route path="/in-town/:category" element={<CategoryLanding />} />

          {/* 🧠 GLOBAL SURVEY */}
          <Route
            path="/survey/:slug"
            element={<SurveyPage />}
          />

          {/* ✅ SURVEY COMPLETE (AI REPORT) */}
          <Route
            path="/survey/:slug/complete"
            element={<SurveyCompletePage />}
          />

          {/* VIEW REPORT */}
          <Route
            path="/report/:customerId"
            element={<ViewReport />}
          />
          {/* ❓ FAQ */}
          <Route
            path="/faqs"
            element={<FAQPage />}
           />


          {/* 🧰 TOOLS */}
          <Route
            path="/tools/cost-estimator"
            element={<CostEstimatorPage />}
          />

          <Route
            path="/tools/project-diagnostic"
            element={<ProjectDiagnosticPage />}
          />

          <Route
            path="/tools/measurement-calculator"
            element={<MeasurementCalculatorPage />}
          />

          <Route
            path="/tools/accessibility-planner"
            element={<AccessibilityPlannerPage />}
          />

          <Route
            path="/tools/inspiration-explorer"
            element={<InspirationExplorerPage />}
          />

          <Route
            path="/tools/project-readiness"
            element={<ProjectReadinessPage />}
          />

          <Route
            path="/tools/financing"
            element={<FinancingPage />}
          />

          <Route
            path="/tools/property-report"
            element={<PropertyReportPage />}
          />
          <Route path="/room-ideas" element={<RoomIdeaGenerator />} />

          <Route
            path="/california-hidden-tax-fee-transparency-petition"
            element={<CaliforniaHiddenTaxFeeTransparencyPetition />}
          />

          <Route path="/do-not-sell" element={<DoNotSell />} />
          <Route path="/privacy/confirmed" element={<PrivacyConfirmed />} />

          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* ❌ FALLBACK */}
          <Route
            path="*"
            element={
              <div style={{ padding: 40 }}>
                <h1>404 – Page not found</h1>
              </div>
            }
          />
        </Routes>
      </ToolModalProvider>
    </>
  );
}
